import { render, staticRenderFns } from "./WebChatStatsChart.vue?vue&type=template&id=151c25d2&scoped=true&"
import script from "./WebChatStatsChart.vue?vue&type=script&lang=js&"
export * from "./WebChatStatsChart.vue?vue&type=script&lang=js&"
import style0 from "./WebChatStatsChart.vue?vue&type=style&index=0&id=151c25d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c25d2",
  null
  
)

export default component.exports